import { render, staticRenderFns } from "./SuccessCheckmarkAnimation.vue?vue&type=template&id=253f5d37&scoped=true&"
import script from "./SuccessCheckmarkAnimation.vue?vue&type=script&lang=ts&"
export * from "./SuccessCheckmarkAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessCheckmarkAnimation.vue?vue&type=style&index=0&id=253f5d37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f5d37",
  null
  
)

export default component.exports